<template>
  <div class="wine-product-page">
    <b-container>
      <b-row>
        <b-col v-if="item">
          <node-element-local-tasks
            v-if="item"
            :itemid="itemid"
          />
          <div
            v-if="notPublished"
            class="messages warning"
          >
            Not published
          </div>
        </b-col>
      </b-row>
    </b-container>

    <template v-if="item">
      <component
        :is="productDetailPageComponent"
        :item="item"
      />
    </template>

    <page-content-creator
      :itemid="itemid"
      pos="bottom"
    />
  </div>
</template>

<script>
const cartMultiType = {
  0: 'sameprice',
  1: 'never',
  2: 'always'
}

const gqlDoc = `
  query faqs {
    winefaqlist {
      id
      status
      created
      featured
      title
      body
      category
    }
  }
`

export default {
  name: 'page-content-type-wine-product',
  headData: true,
  headTitle() {
    return (this.item)
      ? this.item.title
      : ''
  },
  props: {
    nid: {
      type: Number,
      required: true
    }
  },
  computed: {
    item() {
      return this.$store.getters['products/productsByItemID'][this.nid]
    },
    itemid: function() {
      return this.item ? this.item.nid : null
    },
    notPublished: function() {
      return this.item ? this.item.status == 0 : null
    },
    productDetailPageComponent: function() {
      const themeSettings = this.$store.getters.getModuleSetting('theme', 'products')

      return (themeSettings && Object.keys(themeSettings).includes('catalogue-single')) ? themeSettings['catalogue-single'] || 'wine-product-detail-page-0000' : 'wine-product-detail-page-0000'
    },
    node: function() {
      return JSON.parse(JSON.stringify(this.$store.getters['node/getByPath'](this.$route.path)))
    }
  },
  mounted() {
    setTimeout(() => {
      if (this.item) {
        this.$eventHub.$emit('eventReport', {
          event: 'view_wine',
          ecommerce: {
            item_id: this.item.id,
            item_name: this.item.title,
            price: this.item.price,
            sku: this.item.sku,
            wine_type: this.item.wine_type,
            wine_series: this.item.series,
            wine_varietal: this.item.varietal instanceof Array ? this.item.varietal.join(', ') : this.item.varietal,
            wine_varietal_list: this.item.varietal instanceof Array ? this.item.varietal : [this.item.varietal],
            wine_varietal_first: this.item.varietal instanceof Array ? this.item.varietal[0] : this.item.varietal,
            product_type: this.item.producttype,
            sweetness: this.item.sweetnessDesc,
            bottle_size: this.item.bottlesize,
            vintage: this.item.vintage,
            wine_body: this.item.winebody,
            path: this.item.path_prefixed_slash,
            image: this.item.image
          }
        })
      }
    }, 250)
  }
}
</script>

<style>
</style>
